import BaseFormFactory from "@src/forms/form-factory-default.vue";

export default class FormBuilder {
  constructor() {
    this.props = {
      fields: [],
    };
    this.FormFactory = BaseFormFactory;
  }

  withProvider(provider) {
    this.provider = provider;
    return this;
  }
  changeFormFactory(FormFactory) {
    this.FormFactory = FormFactory;
    return this;
  }

  addField(field) {
    this.props.fields.push(field);
    return this;
  }

  build() {
    const Provider = this.provider;
    const props = this.props;
    const FormFactory = this.FormFactory;

    return {
      props: {
        currentValues: {
          default: null,
          type: Object,
        },
        notGenericFields: {
          type: Array,
          default: () => ["complemento", "pontoReferencia"],
        },
        hasPadding: {
          type: Boolean,
          default: () => false,
        },
      },
      render(h) {
        return h(Provider, [
          h(
            FormFactory,
            {
              props: {
                hasPadding: this.hasPadding,
                currentValues: this.currentValues,
                notGenericFields: this.notGenericFields,
                ...props,
              },
            },
            this.$slots.default
          ),
        ]);
      },
    };
  }
}
